import { addressValuesToClientData, clientDataToAddressValues } from 'component/form/addressForm/mapper';
import { ButtonVariant } from 'component/button/buttonProps';
import { flc } from 'utils/strings/firstLetterCapitalize';
import { getNavigationNameForPageEnum, getSubtitleForPageEnum, getTitleForPageEnum, PageEnum } from 'route/page';
import { getUrlAdysHomepage } from 'config/url';
import { ratControlServiceRoute, ratControlSuccessRoute } from 'route/routeRatControl';
import { ServiceType } from 'common/serviceType';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddressForm, { AddressFormValues } from 'component/form/addressForm';
import PageWrapper from 'component/pageWrapper';
import React, { useEffect } from 'react';
import useBillingClient from 'store/order/hook/address/useBillingClient/useBillingClient';
import useDeliveryClient from 'store/order/hook/address/useDeliveryClient/useDeliveryClient';
import useSetBillingClientWasSetAction from 'store/order/hook/address/useSetBillingClientWasSetAction/useSetBillingClientWasSetAction';
import useSetDeliveryClientWasSetAction from 'store/order/hook/address/useSetDeliveryClientWasSetAction/useSetDeliveryClientWasSetAction';
import useSetPostalCodeIsNotInSystemAction from 'store/order/hook/postalCodeIsNotInSystem/useSetPostalCodeIsNotInSystemAction/useSetPostalCodeIsNotInSystemAction';
import useSetServiceTypeWasSetAction from 'store/order/hook/order/useSetServiceTypeWasSetAction/useSetServiceTypeWasSetAction';

const RatControlAddressPage: React.FC = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const deliveryClient = useDeliveryClient();
    const setDeliveryClientWasSet = useSetDeliveryClientWasSetAction();
    const billingClient = useBillingClient();
    const setBillingAddressDataWasSet = useSetBillingClientWasSetAction();
    const { setPostalCodeIsNotInSystemWasSet } = useSetPostalCodeIsNotInSystemAction();
    const setServiceTypeWasSet = useSetServiceTypeWasSetAction();

    useEffect(() => {
        setServiceTypeWasSet(ServiceType.ratControl);
    }, [setServiceTypeWasSet]);

    const onUnknownZip = (zip: string) => {
        const subject = t('order.screen.address.unexpectedZipMailSubject', { postalCode: zip });
        setPostalCodeIsNotInSystemWasSet();
        history.push(ratControlSuccessRoute.url());
        window.open('mailto:info@adys.lu?subject=' + subject);
    };

    const onSubmit = async (values: AddressFormValues) => {
        await setDeliveryClientWasSet(addressValuesToClientData(values.delivery));
        await setBillingAddressDataWasSet(values.billing !== undefined ? addressValuesToClientData(values.billing) : null);
        history.push(ratControlServiceRoute.url());
    };

    return (
        <PageWrapper
            page={PageEnum.ratControlAddress}
            pageTitle={getNavigationNameForPageEnum(PageEnum.ratControlAddress)}
            serviceType={ServiceType.ratControl}
            wizardItems={[PageEnum.ratControlAddress, PageEnum.ratControlService, PageEnum.ratControlConfirm, PageEnum.ratControlPayment]}
            title={flc(getTitleForPageEnum(PageEnum.ratControlAddress))}
            subtitle={getSubtitleForPageEnum(PageEnum.ratControlAddress)}
            price={undefined}
            secondButton={{
                type: 'submit',
                form: 'addressForm',
                arrowContinue: true,
                text: t('order.navigation.continue'),
                variant: ButtonVariant.contained,
            }}
            firstButton={{
                onClick: () => {
                    window.location.href = getUrlAdysHomepage();
                },
                text: t('order.navigation.cancel'),
                variant: ButtonVariant.outlined,
            }}
        >
            <AddressForm
                id="addressForm"
                onSubmit={onSubmit}
                onUnknownZip={onUnknownZip}
                defaultValues={{
                    delivery: deliveryClient !== undefined ? clientDataToAddressValues(deliveryClient) : undefined,
                    billing: billingClient !== undefined && billingClient !== null ? clientDataToAddressValues(billingClient) : undefined,
                }}
            />
        </PageWrapper>
    );
};

export default RatControlAddressPage;
